import { queryOptions } from "@tanstack/react-query";
import { queryPolicies } from "@sx/api-client";

import { factoryQueryKeys } from "../../lib/query-keys";
import type { api } from "./api";

/** The floor grant, named once so Production's loader and layout and the pages outside
 *  Production that serve the floor (Orders, Robots) ask for the same thing. The door
 *  client is passed in, never imported, so the loader that names this stays out of the
 *  door's chunk. */
export const floorGrantsQuery = (
  principalId: string,
  grants: typeof api.grants,
) =>
  queryOptions({
    queryKey: factoryQueryKeys.principal(principalId, "grants"),
    queryFn: grants,
    ...queryPolicies.reference,
  });
